import Factory from '../di/factory';


class PageComponentFactory extends Factory {

}


export default PageComponentFactory;
